import { useBreakpoint } from '../../hooks/useBreakpoint';
import { formatSlopeSummary } from '../Wizard/inputs/BaseSlopeControls';

/**
 * SlopeIndicator — dezenter, read-only Gefälle-Indikator im Editor (#624).
 *
 * Zeigt das Grundgefälle des Gartens (Pfeil in Fallrichtung + „Gefälle 1,2 m
 * nach SO"), platziert unter dem CompassWidget. Bearbeitet wird das Gefälle
 * im Wizard (Phase 2, #625: zusätzlich in den Garten-Einstellungen).
 *
 * Auf Mobile nicht gerendert: die fixe Position (right: 316px, am
 * Desktop-Properties-Panel ausgerichtet, wie das CompassWidget) ragt auf
 * schmalen Viewports links aus dem Bild; der Mobile-Editor ist read-only,
 * das Gefälle ist dort in der 3D-Ansicht sichtbar.
 *
 * Props:
 *   baseSlope {object|null} — settings.heightDifferences.baseSlope
 *   northAngle {number|null} — settings.northAngle (für Himmelsrichtungs-Label)
 */
const SlopeIndicator = ({ baseSlope, northAngle }) => {
  const { isMobile, isDesktop } = useBreakpoint();
  if (!baseSlope || isMobile) return null;

  const summary = formatSlopeSummary(baseSlope, northAngle);

  return (
    <div
      style={{
        position: 'fixed',
        top: '232px', // unter dem CompassWidget (176px + 48px + 8px)
        // rechts ausgerichtet wie das CompassWidget: Desktop neben dem
        // Properties-Panel (300 px + 16 px), Tablet ohne Panel am Rand
        right: isDesktop ? '316px' : '16px',
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        height: '32px',
        padding: '0 10px',
        backgroundColor: 'white',
        border: '1px solid #D1D5DB',
        borderRadius: '4px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      }}
      title="Grundgefälle — festgelegt im Einrichtungs-Assistenten, sichtbar in der 3D-Ansicht"
      data-testid="slope-indicator"
    >
      <svg
        width="16"
        height="16"
        viewBox="-8 -8 16 16"
        style={{ transform: `rotate(${baseSlope.directionDeg ?? 0}deg)` }}
        aria-hidden="true"
        data-testid="slope-indicator-arrow"
      >
        {/* Pfeil zeigt bei 0° nach oben (Canvas-Winkel-Konvention) */}
        <line x1="0" y1="6" x2="0" y2="-5" stroke="#059669" strokeWidth="2" strokeLinecap="round" />
        <line x1="0" y1="-5" x2="-3.5" y2="-1" stroke="#059669" strokeWidth="2" strokeLinecap="round" />
        <line x1="0" y1="-5" x2="3.5" y2="-1" stroke="#059669" strokeWidth="2" strokeLinecap="round" />
      </svg>
      <span style={{ fontSize: '12px', color: '#374151', whiteSpace: 'nowrap' }}>
        {summary}
      </span>
    </div>
  );
};

export default SlopeIndicator;
